

    <div class="container-fluid">
        <div class="card  card-finance">
            <div class="finance-client-header">
                <div>
                    <div class="card-header card-header-icon card-header-warning">
                    </div>
                    <h3 class="card-title-finance">Stranke</h3>
                </div>

                <div style="width: 100%;">
                    <div class="button-wrapper">
                        <div >
                            <button type="button" class="btn custom-button" [routerLink]="['/finance/statistics']"
                            routerLinkActive="router-link-active" (click)="onCloseClick()" >
                            <mat-icon>close</mat-icon>
                            Odustani
                            </button>
                        
                            <button  type="submit" class=" btn  custom-button"
                            (click)="onSubmit()">
                            <mat-icon>save</mat-icon>
                            Sačuvaj</button>
            
                            <button  type="submit" class="btn   custom-button" (click)="onSubmitNew()">
                                <mat-icon>save</mat-icon>
                            Sačuvaj i nov</button>
                        </div>



 

                    </div>
                </div>
            </div>

            <div class="col-md-8 mr-auto"  *ngIf="!isEdit">
                <h4 class="form-title">Pretražnja NBS API po PIB-u</h4>
                <div class="form-item">
                    <label for="pib">PIB:</label>
                    <mat-form-field appearance="outline">
                        <input matInput type="text" id="pib" [formControl]="pibControl" 
                        [ngClass]="{'error-input': pibControl.invalid && pibControl.touched}"
                        [matAutocomplete]="auto" (input)="onPibInput()">
                
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCompany" (optionSelected)="onOptionSelected($event.option.value)">
                        <mat-option *ngIf="loading">
                            <mat-spinner diameter="20"></mat-spinner> Loading...
                        </mat-option>
                        <mat-option *ngIf="suggestedCompany && !loading" [value]="suggestedCompany">
                            {{ suggestedCompany.companyName }} ({{ suggestedCompany.pib }})
                        </mat-option>
                        <mat-option *ngIf="pibControl.value?.length < 8 && !loading">
                            <span>8 cifara moraju biti uneti</span>
                        </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
               
              
                <div>
                  <mat-error class="select-mat-error" *ngIf="pibControl.hasError('required') && pibControl.touched">
                    PIB je obavezno polje.
                  </mat-error>
                </div>
            </div>
              

            <form [formGroup]="addFinanceForm" (ngSubmit)="onSubmitNew()">
                <div class="row form-container">
                    <div class="col-md-5 mr-auto">
                        <h4 class="form-title">Osnovni podaci</h4>
                        <div class="form-item">
                            <label for="username">Naziv*:</label>
                            <mat-form-field appearance="outline">
                                <input matInput type="text" id="username" formControlName="username">
                                <mat-error *ngIf="addFinanceForm.get('username').hasError('required') && addFinanceForm.get('username').touched">
                                    Naziv je obavezno polje.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div  class="form-item">
                            <label for="address">Adresa*:</label>
                            <mat-form-field appearance="outline">
                                <input matInput type="text" id="address" formControlName="address">
                                <mat-error *ngIf="addFinanceForm.get('address').hasError('required') && addFinanceForm.get('address').touched">
                                    Adresa je obavezno polje.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div  class="form-item">
                            <label for="country">Država*:</label>
                            <mat-form-field appearance="outline">
                            <input matInput type="text" id="country" formControlName="country">
                                <mat-error *ngIf="addFinanceForm.get('country').hasError('required') && addFinanceForm.get('country').touched">
                                    Drzava je obavezno polje.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div  class="form-item">
                            <label for="post">Pošta*:</label>
                            <mat-form-field appearance="outline">
                                <input matInput type="text" id="post" formControlName="post">
                                <mat-error *ngIf="addFinanceForm.get('post').hasError('required') && addFinanceForm.get('post').touched">
                                    Pošta je obavezno polje.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div  class="form-item">
                            <label for="address">PIB*:</label>
                            <mat-form-field appearance="outline">
                                <input matInput type="text" id="pib" formControlName="pib">
                                <mat-error *ngIf="addFinanceForm.get('pib').hasError('required') && addFinanceForm.get('pib').touched">
                                    PIB je obavezno polje.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div  class="form-item">
                            <label for="address">Matični broj*:</label>
                            <mat-form-field appearance="outline">
                                <input matInput type="text" id="indetificationNumber" formControlName="indetificationNumber">
                                <mat-error *ngIf="addFinanceForm.get('indetificationNumber').hasError('required') && addFinanceForm.get('indetificationNumber').touched">
                                    Matični broj je obavezno polje.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div  class="form-item">
                            <label for="password">Grad:</label>
                            <mat-form-field appearance="outline">
                                <input matInput type="text" id="password" formControlName="password">
                            </mat-form-field>
                        </div>
                        <div  class="form-item">
                            <label  for="customer">Kupac:</label>

                            <mat-checkbox formControlName="customer1" (change)="onCustomer1Change($event.target.checked)">
                                Kupac
                            </mat-checkbox>
                            <mat-checkbox formControlName="customer2" (change)="onCustomer2Change($event.target.checked)">
                                Dobavljač
                            </mat-checkbox>
                            <!-- <input type="checkbox"  id="customer1" formControlName="customer1"   (change)="onCustomer1Change($event.target.checked)" >
                            <label  for="customer1">Kupac</label> -->
                            
                            <!-- <input type="checkbox" id="customer2" formControlName="customer2" (change)="onCustomer2Change($event.target.checked)" >
                            <label for="customer2">Dobavljač</label> -->
                        </div>
                        <div  class="form-item">
                            <label for="startState">Početno stanje:</label>
                            <mat-form-field appearance="outline">
                                <input matInput type="number" id="startState" formControlName="startState">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-md-5 mr-auto">
                        <h4 class="form-title">Kontakti</h4>
                        <div  class="form-item">
                            <label for="firstName">Ime i prezime:</label>
                            <mat-form-field appearance="outline">
                                <input matInput type="text" id="firstName" formControlName="firstName">
                            </mat-form-field>
                        </div>
                        <div class="form-item">
                            <label for="email">E-pošta:</label>
                            <mat-form-field appearance="outline">
                                <input matInput type="email" id="email" formControlName="email">
                            </mat-form-field>
                        </div>
                        <div  class="form-item">
                            <label for="name">Naziv:</label>
                            <mat-form-field appearance="outline">
                                <input matInput type="text" id="name" formControlName="name">
                            </mat-form-field>
                        </div>
                        <div class="form-item">
                            <label for="phone">Telefon:</label>
                            <mat-form-field appearance="outline">
                                <input matInput type="phone" id="phone" formControlName="phone">
                            </mat-form-field>
                        </div>
                        <div  class="form-item">
                            <label for="note">Napomena:</label>
                            <mat-form-field appearance="outline">
                                <input matInput class="inputleft" type="note" id="note" formControlName="note">
                            </mat-form-field>
                        </div>
                        <div class="form-item">
                            <label for="fax">Fax:</label>
                            <mat-form-field appearance="outline">
                                <input matInput type="fax" id="fax" formControlName="fax">
                            </mat-form-field>
                        </div>
                        <div class="form-item">
                            <label for="mobilePhone">Mobilni telefon:</label>
                            <mat-form-field appearance="outline">
                                <input matInput type="text" id="mobilePhone" formControlName="mobilePhone">
                            </mat-form-field>
                        </div>
                        <div  class="form-item">
                            <label  for="customer">Slanje na mail:</label>
                            <mat-checkbox formControlName="sendEmail" (change)="onSendEmialChange($event.target.checked)"></mat-checkbox>
                            <!-- <input type="checkbox"  id="sendEmail" formControlName="sendEmail"   (change)="onSendEmialChange($event.target.checked)" > -->
                        </div>
                        <div class="fomr-item">
                            <mat-checkbox formControlName="isSrbClient">Je Srpska organizacija</mat-checkbox>
                        </div>



                        <div class="form-item">
                            <mat-checkbox formControlName="isGovernmentCompany" (change)="onIsGovernmentCompanyChange($event.checked)">
                                Da li je državna kompanija
                            </mat-checkbox>
                          </div>
                          
                          <div formGroupName="governmentCompanyAdditionalInfo" *ngIf="addFinanceForm.get('isGovernmentCompany').value">
                            <div class="form-item">
                              <label for="jbkjs">JBKJS:</label>
                              <mat-form-field appearance="outline">
                                <input matInput type="text" id="jbkjs" formControlName="jbkjs">
                                <mat-error *ngIf="addFinanceForm.get('governmentCompanyAdditionalInfo.jbkjs')?.hasError('required') && addFinanceForm.get('governmentCompanyAdditionalInfo.jbkjs')?.touched">
                                  JBKJS is required.
                                </mat-error>
                              </mat-form-field>
                            </div>
                          
                            <div class="form-item">
                              <label for="contractId">Contract ID:</label>
                              <mat-form-field appearance="outline">
                                <input matInput type="text" id="contractId" formControlName="contractId">
                                <mat-error *ngIf="addFinanceForm.get('governmentCompanyAdditionalInfo.contractId')?.hasError('required') && addFinanceForm.get('governmentCompanyAdditionalInfo.contractId')?.touched">
                                  Contract ID is required.
                                </mat-error>
                              </mat-form-field>
                            </div>
                          
                            <div class="form-item">
                              <label for="contractDate">Contract Date:</label>
                              <mat-form-field appearance="outline">
                                <input matInput [matDatepicker]="picker" id="contractDate" formControlName="contractDate">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                                <mat-error *ngIf="addFinanceForm.get('governmentCompanyAdditionalInfo.contractDate')?.hasError('required') && addFinanceForm.get('governmentCompanyAdditionalInfo.contractDate')?.touched">
                                  Contract Date is required.
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          
                    </div>
                </div>


             
            </form>

        </div>
    </div>

  
  